import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { citeAnchor, type CiteAnchor } from '../assistant/citations';
import { BRAND } from '../theme';

export function Section({ title, action, anchor, children }: { title: string; action?: ReactNode; anchor?: CiteAnchor; children: ReactNode }) {
  const id = `section-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  return (
    <Box component="section" aria-labelledby={id} {...(anchor ? citeAnchor(anchor) : {})} sx={{ py: 2, borderBottom: `1px solid ${BRAND.line}` }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="h4" component="h3" id={id}>
          {title}
        </Typography>
        {action}
      </Box>
      {children}
    </Box>
  );
}
